import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Drawer, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import KotDetailView from "./KotDetailView";
import KotHistoryList from "./KotHistoryList";
// kotStatus.ts
export const KOT_STATUS = {
  PREPARING: {
    id: 1,
    label: "Preparing",
    color: "#f59e0b", // orange
  },
  READY: {
    id: 2,
    label: "Ready",
    color: "#22c55e", // green
  },
  CANCELLED: {
    id: 3,
    label: "Cancelled",
    color: "#ef4444", // red
  },
};

export const historyKots = [
  {
    id: 1,
    kotNo: "0005",
    orderNo: "202601036988",
    status: "READY",
    orderType: "Dine In",
    floor: "F3 (First Floor)",
    completedAt: "12:45 PM",
    items: [
      { id: 1, name: "Ice Cream Full", qty: 2 },
      { id: 2, name: "Brownie", qty: 1 },
    ],
  },
  {
    id: 2,
    kotNo: "0004",
    orderNo: "202601036987",
    status: "CANCELLED",
    orderType: "Dine In",
    floor: "F3 (First Floor)",
    completedAt: "12:38 PM",
    cancelReason: "Customer cancelled",
    items: [{ id: 3, name: "Ice Cream Full", qty: 4 }],
  },
  {
    id: 3,
    kotNo: "0003",
    orderNo: "202601036980",
    status: "READY",
    orderType: "Counter",
    floor: "-",
    completedAt: "12:20 PM",
    items: [
      { id: 4, name: "Veg Sandwich", qty: 2 },
      { id: 5, name: "Cold Coffee", qty: 1 },
    ],
  },
];

export default function KotHistoryDrawer({ open, onClose, onReopenKot }) {
  const [mode, setMode] = useState("LIST");
  const [selectedKot, setSelectedKot] = useState(null);

  const handleViewDetails = (kot) => {
    setSelectedKot(kot);
    setMode("DETAIL");
  };

  const handleBack = () => {
    setSelectedKot(null);
    setMode("LIST");
  };

  const handleOnClose = () => {
    if (mode === "DETAIL") {
      setMode("LIST");
    } else {
      onClose();
    }
  };

  return (
    <Drawer anchor="right" open={open} onClose={handleOnClose}>
      <Box
        sx={{
          width: 420,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {mode === "DETAIL" && (
              <IconButton size="small" onClick={handleBack}>
                <ArrowBackIcon />
              </IconButton>
            )}
            <Typography fontWeight={600}>
              {mode === "LIST" ? "KOT History" : `KOT #${selectedKot?.kotNo}`}
            </Typography>
          </Box>

          <IconButton size="small" onClick={handleOnClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ flex: 1, overflowY: "auto" }}>
          {mode === "LIST" ? (
            <KotHistoryList
              kots={historyKots}
              onViewDetails={handleViewDetails}
            />
          ) : (
            <KotDetailView kot={selectedKot} onReopenKot={onReopenKot} />
          )}
        </Box>
      </Box>
    </Drawer>
  );
}
